import React, { useState, useRef, useEffect } from 'react';

export interface ActionItem {
    label: string;
    icon: string;
    onClick: () => void;
    title?: string;
    color?: string;
    disabled?: boolean;
}

interface ActionMenuProps {
    actions: ActionItem[];
}

const ActionMenu: React.FC<ActionMenuProps> = ({ actions }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="action-menu-container" ref={menuRef}>
            {/* Desktop View: row of icon buttons */}
            <div className="desktop-only" style={{ display: 'flex', gap: '8px' }}>
                {actions.map((action, index) => (
                    <button
                        key={index}
                        className="btn btn-secondary btn-sm"
                        title={action.title || action.label}
                        onClick={action.onClick}
                        disabled={action.disabled}
                        style={action.color && !action.disabled ? { background: action.color, color: 'white' } : {}}
                    >
                        <i className={action.icon}></i>
                    </button>
                ))}
            </div>

            {/* Mobile View: single dropdown button */}
            <div className="mobile-only action-dropdown">
                <button
                    className="action-dropdown-toggle"
                    onClick={() => setIsOpen(!isOpen)}
                    title="Azioni"
                >
                    <i className="fas fa-bars"></i>
                </button>
                {isOpen && (
                    <div className="action-dropdown-menu">
                        {actions.map((action, index) => (
                            <button
                                key={index}
                                className="action-dropdown-item"
                                disabled={action.disabled}
                                onClick={(e) => {
                                    if (action.disabled) return;
                                    e.stopPropagation();
                                    action.onClick();
                                    setIsOpen(false);
                                }}
                                style={action.disabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                            >
                                <i className={action.icon}></i>
                                {action.label}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ActionMenu;
